import utils from "../../../utils/utils.js";

export default {
  async unmaskFeedTitle(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UnmaskFeedTitle`,
      "PUT",
      null,
      payload
    );
  },
    async changeFeederConfirmation(context, payload) {
    await utils.utility.fetch(
      `api/Setting/ChangeFeederConfirmation`,
      "PUT",
      null,
      payload
    );
  },
};
